module.exports = __webpack_public_path__ + "static/anusha-c1527c5dbab037d7849bc919638c8c15.jpg";